<template>
  <div class="sex-content" :id="chartId">
    <div class="hidden-chart-name">
      {{title}} <b>{{charDateTitle}}</b>
    </div>
    <doughnut-chart
      v-if="isLoaded"
      :chart-data="dataDoughnutCollection"
      :options="doughnutOptions"
      class="sex-content__chart"
      :height="350"
    ></doughnut-chart>
    <div class="chart-show-labels" data-html2canvas-ignore="true" @click="toggleLabel">
      <el-checkbox :value="showLabel" @change="toggleLabel">{{$t('feed.audit.sex.body.captions')}}</el-checkbox>
    </div>
    <a href="" :id="`download${chartId}`"></a>
  </div>
</template>

<script>
  // chart
  import { DoughnutChart } from "../../../../../../../../components/charts";

  // mixins
  import sex from "../../../../../../../../mixins/chart/sex";
  import saveImage from "../../../../../../../../mixins/saveImage";

  // config
  import sexConfig from "../../../../../../../../config/sexConfig";

  // moment
  import moment from 'moment';

  export default {
    name: "SexBody",
    props: {
      data: {
        type: Object,
        required: true
      },
      chartName: {
        type: String
      },
      saveChart: {
        type: Boolean,
        default: false
      },
      title: {
        type: String
      }
    },
    data() {
      return {
        sexConfig: this.$t('feed.audit.sex.body.config'),
        chartId: "Sex",
        format: "DD.MM.YYYY",
        showLabel: true,
      }
    },
    methods: {
      toggleLabel () {
        this.showLabel = !this.showLabel;
      },
    },
    computed: {
      chartDate() {
        return this.$store.getters.getAuditPeriod(this.chartName);
      },
      isLoaded() {
        return this.$store.getters.isAuditLoaded(this.chartName);
      },
      charDateTitle () {
        return `${moment(this.chartDate[0]).format(this.format)} - ${moment(this.chartDate[1]).format(this.format)}`;
      },
    },
    mixins: [
      sex,
      saveImage
    ],
    components: {
      DoughnutChart
    }
  };
</script>

<style>
  @import "../../../../../../../../style/tonal.css";
  .sex-content__chart {
    margin-bottom: 10px;
  }
  .chart-show-labels {
    display: flex;
    justify-content: start;
    padding: 20px 10px;
    font-size: 16px;
  }
</style>
